<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/dailyDPRGoals/index')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateSubmit">
              <div class="mb-10 text-left">
                <div class="mb-5">Branch</div>
                <b-form-select name="name" v-validate="'required'" v-model="addData.branch_id" class="form-control">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
                <span class="error">{{ errors.first('name') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Date</div>
                <input type="month" class="form-control" v-validate="'required'" name="date" min="2000-01" v-model="date">
                <span class="error">{{ errors.first('date') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Daily DPR Name</div>
                <b-form-select name="name" v-validate="'required'" v-model="addData.daily_dpr_subcategory_id" class="form-control">
                  <option value="null">Please select</option>
                  <option v-for="item in items" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
                <span class="error">{{ errors.first('name') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Goal</div>
                <b-form-input v-model="addData.goal" name="goal" v-validate="'required|numeric'" type="text"></b-form-input>
                <span class="error">{{ errors.first('goal') }}</span>
              </div>
              <!-- {{editData.receipt_date}} -->
              <div class="text-right">
                <button class="btn-primary pt-5 pb-5">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addGoals',
  data: function () {
    return {
      items: [],
      date: null,
      addData: {
        daily_dpr_subcategory_id: null,
        branch_id: null,
        goal: '',
        month: '',
        years: '',
      }
    }
  },
  methods: {
    validateSubmit () {
      let splitDate = this.date.split('-')
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.addData.years = splitDate[0]
          this.addData.month = splitDate[1]
          axios.post('crm/v1/daily_dpr_goals/', this.addData).then(response => {
            this.$router.push('/dailyDPRGoals/index')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('crm/v1/daily_dpr_subcategory?sorting=id&sorting_type=asc').then(response => {
        this.items = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
